import { useState } from "react";
import { siteConfig } from "@/mocks/siteConfig";

const faqs = [
  {
    q: `什么是 ${siteConfig.name}？`,
    a: `${siteConfig.name} 是一个综合性智能平台，提供数据分析、团队协作、自动化流程等一站式服务。它帮助企业及个人实现高效的数字化管理和协作，支持多端无缝同步，让工作变得更加轻松。`,
  },
  {
    q: `${siteConfig.name} 支持哪些平台？`,
    a: `${siteConfig.name} 全面支持 Windows、macOS、iOS 和 Android 四大平台。你可以在不同设备间无缝切换，所有数据实时同步，确保随时随地都能访问你的工作空间。Web 端也提供了完整的功能体验。`,
  },
  {
    q: `如何开始使用 ${siteConfig.name}？`,
    a: `访问 ${siteConfig.name} 官网注册账号即可免费开始使用。我们为新手提供了详细的使用教程和视频指南，帮助你快速上手。注册后你将获得 14 天的高级功能免费试用期。`,
  },
  {
    q: `${siteConfig.name} 的数据安全性如何？`,
    a: `${siteConfig.name} 采用银行级加密技术，所有数据在传输和存储过程中都经过严密保护。我们已通过 ISO 27001 和 SOC 2 Type II 等国际安全认证，完全符合全球主流数据保护法规的要求。`,
  },
  {
    q: `${siteConfig.name} 适合哪些用户？`,
    a: `${siteConfig.name} 适用于各种规模的企业和团队，从初创公司到大型企业都可以从中受益。无论是项目经理、数据分析师、开发团队还是市场运营人员，都能在 ${siteConfig.name} 找到适合自己的功能。`,
  },
  {
    q: `${siteConfig.name} 是否提供 API 接口？`,
    a: `是的，${siteConfig.name} 提供了丰富的 RESTful API 接口和 SDK，支持 Python、JavaScript、Java 和 Go 等主流编程语言。你可以轻松将 ${siteConfig.name} 集成到现有的企业系统中。`,
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.a,
      },
    })),
  };

  return (
    <section className="w-full py-20 md:py-28 bg-background-100">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="w-full max-w-3xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            常见问题
          </h2>
          <p className="text-foreground-500 leading-relaxed">
            关于 {siteConfig.name} 的常见疑问，在这里找到答案
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-white border border-foreground-100 overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(index)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
                aria-expanded={openIndex === index}
              >
                <span className="text-sm md:text-base font-medium text-foreground-950 pr-4">
                  {faq.q}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-400 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? "rotate-180" : ""
                  }`}
                />
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? "max-h-96 pb-5" : "max-h-0"
                }`}
              >
                <p className="px-6 text-sm text-foreground-500 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}